@if (message) {
  <div
    class="toast"
    [class.success]="type === 'success'"
    [class.error]="type === 'error'"
    [class.warning]="type === 'warning'"
  >
    <p class="text">{{ message }}</p>
    <button class="close" (click)="message = null">+</button>
  </div>
}
